/** @format */

import {ButtonProps} from '@mui/material';

import {Root} from './styles';
import {SegmentedButtonProps} from './types';

type Props = SegmentedButtonProps & ButtonProps;

const SegmentedRadioButton = ({size = 'medium', active, ...props}: Props) => {
  return <Root size={size} active={active} disableRipple {...props} />;
};

export {SegmentedRadioButton};
